import { useEffect, useRef, useState } from 'react';
import '../Assets/css/captcha.css';
import "../lib/slidercaptcha";

const Captcha = ({onSendData}) => {
  const ref = useRef();
  const captcha = useRef();
  const [keyRender, resetKeyRender] = useState(0);

//   const toggleCatpcha = () => {
//     if (captcha.current) {
//       captcha.current = null;
//       resetKeyRender(prev => prev+1);
//       return;
//     }

//     if (ref.current && !captcha.current) {
//       captcha.current = window.sliderCaptcha(
//         {
//             element: ref.current,
//             loadingText: 'Loading...',
//             failedText: 'Try again',
//             barText: '',
//             repeatIcon: 'fa fa-redo',
//             onSuccess: function () {
//                 setTimeout(function () {
//                     // alert('Your captcha is successfully verified.');
//                     onSendData(true);
//                     captcha.current.reset();
//                 }, 1000);
//             },
//             onFailure: function () {
//                 onSendData(false);
//             },
//         })
//     } else {
//         onSendData(false);
//     }
//   }

  useEffect(() =>{
    if (ref.current && !captcha.current) {
      captcha.current = window.sliderCaptcha(
        {
            element: ref.current,
            loadingText: '',
            failedText: '',
            barText: '',
            repeatIcon: 'fa fa-redo',
            onSuccess: function () {
                setTimeout(function () {
                    // alert('Your captcha is successfully verified.');
                    onSendData(true);
                    captcha.current.reset();
                }, 1000);
            },
            onFail: function () {
                onSendData(false);
            },
        })
    } else {
        onSendData(false);
    }
  }, []);

  return (
    <>
      <div key={keyRender} ref={ref}></div>
      {/* <div className='card'>
        <button onClick={toggleCatpcha}>Toggle Captcha</button>
      </div> */}
      {/* <div class="w-[30px] h-[30px] bg-[#2776c3] border-none shadow-[0_0_3px_rgba(0,0,0,0.3)] cursor-pointer transition-background duration-200 flex items-center justify-center rounded-[10px]">
        <div class="w-[1px] h-[10px] bg-white ml-[4px] mr-[5px]">
        </div>
        <div class="w-[1px] h-[10px] bg-white mr-[5px]">
        </div>
        <div class="w-[1px] h-[10px] bg-white mr-[5px]">
        </div>
      </div> */}
    </>
  )
}

export default Captcha
